/**
 * Actions for Static Data
 */

import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('StaticData');

export const setStaticData = actionCreator<IStaticDataState>('SET_STATIC_DATA_STATE');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/actions/staticData.ts